var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0288D1",
    d: "M56 49.333A6.666 6.666 0 0 1 49.333 56H14.667A6.667 6.667 0 0 1 8 49.333V14.667A6.667 6.667 0 0 1 14.667 8h34.666A6.666 6.666 0 0 1 56 14.667v34.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 25.333h6.667V48H16V25.333Zm3.313-2.666h-.037c-1.99 0-3.276-1.483-3.276-3.335C16 17.44 17.327 16 19.352 16c2.028 0 3.277 1.44 3.315 3.332 0 1.85-1.287 3.335-3.354 3.335ZM48 48h-6.667V35.868c0-2.93-1.633-4.93-4.256-4.93-2.001 0-3.084 1.349-3.609 2.653-.192.466-.135 1.757-.135 2.409v12h-6.666V25.333h6.666v3.488c.962-1.488 2.467-3.488 6.318-3.488 4.77 0 8.348 3 8.348 9.699L48 48Z"
  })));
};
export default SvgLinkedinIcon;